import { j as r } from "./atoms-v218.js";
import { forwardRef as g, useCallback as f } from "react";
import { Gallery as h } from "./atoms-v2819.js";
import { ScreenReaderText as v } from "./atoms-v236.js";
import { useBreakpoints as b } from "./atoms-v251.js";
import { Variant1 as y } from "./atoms-v2820.js";
import { Variant2 as j } from "./atoms-v2821.js";
import { Variant3 as B } from "./atoms-v2822.js";
const A = g(
  ({ className: s, i18n: d = {}, id: u, onView: a = void 0, slides: e = [], title: m, variant: l = "v1", ...i }, c) => {
    const { current: p } = b(), t = {
      navButtonNextAriaLabel: "Navigate to next slide.",
      navButtonPreviousAriaLabel: "Navigate to previous slide.",
      slideButtonAriaLabel: "View this image at a larger size.",
      viewAllButtonAriaLabel: "View all images in a lightbox.",
      viewAllButtonText: "View all",
      ...d
    }, o = f((x) => a == null ? void 0 : a(e, x), [a, e]), n = ["small", "medium"].includes(p);
    return /* @__PURE__ */ r.jsxs(
      h,
      {
        $variant: l,
        "aria-labelledby": "galleryheading",
        className: s,
        id: u,
        ref: c,
        tagName: "section",
        children: [
          m && /* @__PURE__ */ r.jsx(v, { id: "galleryheading", tagName: "h4", children: m }),
          l === "v1" && !n && /* @__PURE__ */ r.jsx(y, { handleOnView: a && o, i18n: t, slides: e, ...i }),
          l === "v2" && !n && /* @__PURE__ */ r.jsx(j, { handleOnView: a && o, i18n: t, slides: e, ...i }),
          (l === "v3" || n) && /* @__PURE__ */ r.jsx(
            B,
            {
              handleOnView: a && o,
              i18n: t,
              slides: e,
              ...i
            }
          )
        ]
      }
    );
  }
);
A.displayName = "Blocks.Gallery";
export {
  A as Gallery
};
